import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { IGameTypeSpectator } from "../../IGameTypeSpectator";
import { TournamentTypeShootout } from "../TournamentTypeShootout";

export class TournamentTypeShootoutSpectator extends TournamentTypeShootout implements IGameTypeSpectator {
    public get isGameTypeSpectator(): boolean {
        return true;
    }
}
classImplementsInterfaces(TournamentTypeShootoutSpectator, "IGameTypeSpectator");
